import React from 'react';
import ReactDOM from 'react-dom';
import App from './ui/App';
import reportWebVitals from './reportWebVitals';
import ErrorMessage from './ui/cmp/message/ErrorMessage';
import AppTranslation from './app/AppTranslation';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './assets/theme';
import { AppCtxProvider } from './app/ctx-provider/useAppCtx';
import { RkCtxProvider } from './consumer/rk/ctx-provider/useRkCtx';
import { StylesProvider } from '@material-ui/core/styles';
import { WizardFormProvider } from './ui/page/wizard/ctx-provider/useWizardFormCtx';
import AppLogger from './app/AppLogger';

interface RenderAppFunc {
  (jwt?: string, abTestVersion?: string): void
}

const renderApp: RenderAppFunc = (jwt?: string, abTestVersion?: string) => {
  function getRootElement() {
    return document.getElementById('rhldTarifrechnerHaftpflichtEk');
  }

  // Render App

  try {
    ReactDOM.render(

      <React.StrictMode>
        <ThemeProvider theme={theme}>
          {/* 
          ================
          injectFirst:
          ================
          Controlling priority : 
          If you don't want to mark style attributes with !important, 
          you need to change the CSS injection order
          https://material-ui.com/guides/interoperability/#controlling-priority-%EF%B8%8F-4

          The StylesProvider component has an injectFirst prop 
          to inject the style tags first in the head (less priority):
          https://material-ui.com/styles/advanced/ */}
          <StylesProvider injectFirst>
            <AppCtxProvider abTestVersion={abTestVersion}>
              <RkCtxProvider>
                <WizardFormProvider>
                  <App jwt={jwt} />
                </WizardFormProvider>
              </RkCtxProvider>
            </AppCtxProvider>
          </StylesProvider>
        </ThemeProvider>

      </React.StrictMode>,
      getRootElement()
    );
  } catch (error) {
    AppLogger.error('global exception handler', error);
    ReactDOM.render(<ErrorMessage />, getRootElement());
  }
}

// global variable in a typescript module
declare global {
  interface Window {
    dataLayer: any[] // Marketing: google tag manager
    //gtag: (...arg: any[]) => void,
    CCM: any // Marketing: CCM19 (Cookie consent Manager)
  }
}

(function initApp() {
  // Language Translation mit counterpart
  AppTranslation.setUpCounterpartTranslation();

  // ******************************
  // JWT wird an das Backend uebergeben.
  // ******************************
  const url_string = window.location.href
  const url = new URL(url_string);
  const jwtParam = url.searchParams.get("jwt");
  const jwt = jwtParam ? jwtParam : undefined;
  const abTestVersionParam = url.searchParams.get("ab");
  const abTestVersion:string|undefined = abTestVersionParam ? abTestVersionParam : undefined;

  renderApp(jwt, abTestVersion);
})(); // Function wird aufgerufen

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
